import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
// import { FaPlus } from 'react-icons/fa'
// import { Link } from 'react-router-dom'

// eslint-disable-next-line react/prop-types
const ServiceCard = ({ title, icon, description }) => {
  const { t } = useTranslation();
  return (
    <div className="col-lg-4 col-md-6">
      <div
        className={
          i18next.language != "fr"
            ? "single-service-inner style-3"
            : "single-service-inner1 style-3"
        }
      >
        <div className="thumb">
          <img src={icon} alt="img" />
        </div>
        <div className="details">
          <h5>
            {t(title)}
            {/* <Link to={`/service/${id}`}></Link> */}
          </h5>
          <p>{t(description)}</p>
          {/* <Link className="read-more-text" to={`/service/${id}`}>
            Touch More <FaPlus />
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
